import React from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import PhonePromptContent from './PhonePromptContent';
import { Button } from 'antd';

/**
 * A dynamic modal that displays either quiz prompt or phone collection
 * based on what's needed, but never both at the same time
 */
function DynamicPromptModal({ type, visible, onClose }) {
  const navigate = useNavigate();

  const handleTakeQuiz = () => {
    navigate('/quiz');
    onClose();
  };

  const getModalTitle = () => {
    switch (type) {
      case 'quiz':
        return 'Complete Your Profile';
      case 'phone':
        return 'Enable Event Reminders';
      default:
        return '';
    }
  };

  const renderContent = () => {
    switch (type) {
      case 'quiz':
        return (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <h3 style={{ marginBottom: '16px' }}>Tell us what you're interested in!</h3>
            <p style={{ marginBottom: '24px' }}>
              Complete our quick preferences quiz to help us recommend events that match your interests.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <Button 
                onClick={onClose}
                // style={{
                //   padding: '8px 16px',
                //   border: '1px solid #d9d9d9',
                //   borderRadius: '4px',
                //   background: 'white',
                //   cursor: 'pointer'
                // }}
              >
                Maybe Later
              </Button>
              <Button 
                type="primary"
                onClick={handleTakeQuiz}
                // style={{
                //   padding: '8px 16px',
                //   border: '1px solid #1890ff',
                //   borderRadius: '4px',
                //   background: '#1890ff',
                //   color: 'white',
                //   cursor: 'pointer'
                // }}
              >
                Take the Quiz
              </Button>
            </div>
          </div>
        );
      case 'phone':
        return <PhonePromptContent onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      title={getModalTitle()}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={450}
    >
      {renderContent()}
    </Modal>
  );
}

export default DynamicPromptModal; 